module.exports = __webpack_public_path__ + "img/delete.f763d2fd.svg";